<script>
  import FaceClassifier from './FaceClassifier.svelte';
  import Reclassify from './Reclassify.svelte';

	export let name;
</script>



<main>
	<!-- <Reclassify/> -->
	<FaceClassifier />

	
</main>

<style>
	main {
		text-align: center;
		padding: 0em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>